export default [
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 506,
      left: 259
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 70,
      left: 290
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 11,
      left: 349
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 70,
      left: 392
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 32,
      left: 408
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 132,
      left: 478
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 168,
      left: 494
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 254,
      left: 487
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 279,
      left: 479
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 357,
      left: 473
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 359,
      left: 449
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 470,
      left: 373
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 506,
      left: 305
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 511,
      left: 275
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 484,
      left: 214
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 501,
      left: 248
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 376,
      left: 123
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 320,
      left: 80
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 130,
      left: 504
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 101,
      left: 504
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 74,
      left: 520
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 379,
      left: 463
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 34,
      left: 413
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 85,
      left: 468
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 81,
      left: 445
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 89,
      left: 456
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 148,
      left: 484
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 234,
      left: 492
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 321,
      left: 496
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 349,
      left: 452
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 454,
      left: 425
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 498,
      left: 331
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 508,
      left: 286
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 429,
      left: 156
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 346,
      left: 117
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 60,
      left: 361
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 65,
      left: 412
    }
  },
  {
    className: "mapIcon food_fixedalcoholonlyIcon",
    value: "🍺",
    style: {
      opacity: 1,
      top: 515,
      left: 203
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 331,
      left: 115
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 264,
      left: 523
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 416,
      left: 140
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 526,
      left: 237
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 344,
      left: 465
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 421,
      left: 425
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 61,
      left: 301
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 75,
      left: 405
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 262,
      left: 484
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 469,
      left: 413
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 468,
      left: 199
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 393,
      left: 127
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 535,
      left: 345
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 119,
      left: 467
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 316,
      left: 480
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 362,
      left: 87
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 101,
      left: 484
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 332,
      left: 65
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 504,
      left: 314
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 140,
      left: 511
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 80,
      left: 545
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 377,
      left: 444
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 68,
      left: 511
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 510,
      left: 192
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 115,
      left: 453
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 276,
      left: 511
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 329,
      left: 490
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 476,
      left: 366
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 540,
      left: 317
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 430,
      left: 403
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 315,
      left: 110
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 53,
      left: 345
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 42,
      left: 437
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 481,
      left: 101
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 51,
      left: 306
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 160,
      left: 515
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 282,
      left: 106
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 112,
      left: 566
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 111,
      left: 441
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 97,
      left: 526
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 285,
      left: 82
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 525,
      left: 283
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 97,
      left: 570
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 512,
      left: 216
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 100,
      left: 450
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 524,
      left: 298
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 17,
      left: 367
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 72,
      left: 399
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 49,
      left: 418
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 529,
      left: 377
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 120,
      left: 498
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 467,
      left: 102
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 310,
      left: 88
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 29,
      left: 401
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 60,
      left: 491
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 124,
      left: 525
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 329,
      left: 462
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 385,
      left: 434
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 454,
      left: 386
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 271,
      left: 482
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 439,
      left: 422
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 521,
      left: 223
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 290,
      left: 474
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 367,
      left: 121
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 483,
      left: 114
    }
  },
  {
    className: "mapIcon food_fixedIcon",
    value: "🍗",
    style: {
      opacity: 1,
      top: 539,
      left: 295
    }
  },
  {
    className: "mapIcon restroom_familyIcon",
    value: "👪",
    style: {
      opacity: 1,
      top: 67,
      left: 482
    }
  },
  {
    className: "mapIcon restroom_familyIcon",
    value: "👪",
    style: {
      opacity: 1,
      top: 328,
      left: 91
    }
  },
  {
    className: "mapIcon restroom_familyIcon",
    value: "👪",
    style: {
      opacity: 1,
      top: 54,
      left: 469
    }
  },
  {
    className: "mapIcon restroom_familyIcon",
    value: "👪",
    style: {
      opacity: 1,
      top: 320,
      left: 116
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 36,
      left: 420
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 229,
      left: 528
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 313,
      left: 498
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 355,
      left: 483
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 513,
      left: 406
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 546,
      left: 244
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 468,
      left: 181
    }
  },
  {
    className: "mapIcon restroom_menIcon",
    value: "🚹",
    style: {
      opacity: 1,
      top: 348,
      left: 84
    }
  },
  {
    className: "mapIcon restroom_womenIcon",
    value: "🚺",
    style: {
      opacity: 1,
      top: 27,
      left: 394
    }
  },
  {
    className: "mapIcon restroom_womenIcon",
    value: "🚺",
    style: {
      opacity: 1,
      top: 43,
      left: 441
    }
  },
  {
    className: "mapIcon restroom_womenIcon",
    value: "🚺",
    style: {
      opacity: 1,
      top: 262,
      left: 516
    }
  },
  {
    className: "mapIcon restroom_womenIcon",
    value: "🚺",
    style: {
      opacity: 1,
      top: 341,
      left: 487
    }
  },
  {
    className: "mapIcon restroom_womenIcon",
    value: "🚺",
    style: {
      opacity: 1,
      top: 535,
      left: 250
    }
  },
  {
    className: "mapIcon restroom_womenIcon",
    value: "🚺",
    style: {
      opacity: 1,
      top: 416,
      left: 71
    }
  }
];
